import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ExperienceTimeline.css";

const ExperienceTimeline = ({ experiences }) => {
  return (
    <Container
      fluid
      className="experience-section"
      style={{ marginTop: "55px" }}
    >
      <Container>
        <div className="timeline-wrapper">
          {/* SINGLE LINE */}
          <span className="timeline-line" />

          {/* CENTER DOT */}
          {/* <Col md={1} className="timeline-center">
            <span className="dot" />
          </Col> */}

          {experiences.map((exp, index) => (
            <Row key={index} className="timeline-item">
              {/* LEFT */}
              <Col md={4} className="timeline-left">
                <h5 className="company">{exp.company}</h5>
                <span className="duration">{exp.duration}</span>
                {exp.location && <div className="location">{exp.location}</div>}
              </Col>

              {/* CENTER DOT */}
              <Col md={1} className="timeline-center">
                <span className="dot" />
              </Col>

              {/* RIGHT */}
              <Col md={7} className="timeline-right">
                <h5 className="role">{exp.role}</h5>
                <ul>
                  {exp.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </Col>
            </Row>
          ))}
        </div>
      </Container>
    </Container>
  );
};

export default ExperienceTimeline;
